import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Feature from 'components/Feature';
import Can from 'components/Can';
import OrgAbility from 'components/OrgAbility';
import Menu from '@material-ui/core/Menu';
import SvgIcon from '@material-ui/core/SvgIcon';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import useStyles from './VerticalMenu.styled';
import { Divider } from '@material-ui/core';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    minWidth: 100,
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
));

const CardVerticalMenu = ({ anchorEl, items, handleClose }) => {
  const classes = useStyles();

  const menuElement = (item, index, disabled = false, includeDivider = false) => {
    const menuComponent = (
      <MenuItem
        data-cy={item['data-cy']}
        disabled={disabled}
        key={index}
        onClick={() => {
          if (item.onClick) item.onClick();
          handleClose();
        }}
      >
        {item.icon && (
          <ListItemIcon>
            <SvgIcon component={InboxIcon} />
          </ListItemIcon>
        )}
        <ListItemText
          classes={{
            primary: classes.primaryText,
          }}
          primary={item.title}
        />
      </MenuItem>
    );

    return includeDivider ? (
      <>
        {menuComponent}
        <Divider variant="middle" />
      </>
    ) : (
      menuComponent
    );
  };

  return (
    <StyledMenu id="card-menu" anchorEl={anchorEl} onClose={handleClose} open={Boolean(anchorEl)}>
      {items.map((item, index) => {
        if (item.render === false) {
          return null;
        }
        if (item.feature) {
          return (
            <Feature name={item.feature.name} is={item.feature.is} key={index}>
              {menuElement(item, index, false, item.divider)}
            </Feature>
          );
        }

        if (item.can) {
          return (
            <Can I={item.can.action} on={item.can.name} key={index}>
              {menuElement(item, index, false, item.divider)}
            </Can>
          );
        }

        if (item.orgAbility) {
          return (
            <OrgAbility subject={item.orgAbility.subject} key={index}>
              {menuElement(item, index, false, item.divider)}
            </OrgAbility>
          );
        }

        if (item.enabled === false) {
          return <Box key={index}>{menuElement(item, index, true, item.divider)}</Box>;
        }

        if (!item.disabled) {
          return <Box key={index}>{menuElement(item, index, false, item.divider)}</Box>;
        }

        return null;
      })}
    </StyledMenu>
  );
};

CardVerticalMenu.propTypes = {
  hasVerticalMenu: PropTypes.bool,
  verticalMenuItems: PropTypes.array,
};

CardVerticalMenu.defaultProps = {
  verticalMenuItems: [],
  hasVerticalMenu: true,
};

export default CardVerticalMenu;
